export const FETCH_REVIEWS = {
  init: 'reviews/FETCH_REVIEWS/init',
  request: 'reviews/FETCH_REVIEWS/request',
  success: 'reviews/FETCH_REVIEWS/success',
  failure: 'reviews/FETCH_REVIEWS/failure',
} as const;

export const REVIEWS_STORE_NAME = 'reviews' as const;
